import { render } from "./ChooseGoodCard.vue?vue&type=template&id=11f2d8b7"
import script from "./ChooseGoodCard.vue?vue&type=script&lang=js"
export * from "./ChooseGoodCard.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/driveapp2.experimental.locatiers.fr/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__